t = require('views/internal/teacup-with-helpers')('member_detail')

module.exports = t.renderable (data) ->
  { upsellEnabled, showOrgs, avatarHash, fullName, hasCrown, editable, initials, username, isMe, hasAccount, accountProblem } = data

  t.div '.tabbed-pane-header', ->
    t.div '.tabbed-pane-header-wrapper.u-clearfix', ->

      t.a class: t.classify('tabbed-pane-header-image': true, 'profile-image': true, 'is-editable': editable, 'js-change-avatar-profile': editable, 'is-gold': hasCrown), href: '#', ->
        if avatarHash
          t.img '.profile-image-image', src: [avatarDomain, avatarHash, '170.png'].join('/'), alt: fullName
        else
          t.span '.profile-image-initials', ->
            t.text initials
        t.span '.profile-image-change-text', ->
          t.format 'change-avatar'

      t.div '.tabbed-pane-header-details', ->
        t.div '.js-current-details'

        if editable
          t.form '.js-profile-form.hide'

  t.div '.tabbed-pane-nav.u-clearfix', ->

    t.ul ->

      t.li '.tabbed-pane-nav-item', ->
        t.a '.tabbed-pane-nav-item-button.js-member-profile', 'data-tab': 'profile', href: ['', username].join('/'), ->
          t.format 'profile'

      t.li '.tabbed-pane-nav-item', ->
        t.a '.tabbed-pane-nav-item-button.js-member-cards', 'data-tab': 'cards', href: ['', username, 'cards'].join('/'), ->
          t.format 'cards'

      if isMe
        t.li '.tabbed-pane-nav-item', ->
          t.a '.tabbed-pane-nav-item-button.js-member-account', 'data-tab': 'settings', href: ['', username, 'account'].join('/'), ->
            t.format 'settings'

        if upsellEnabled
          if accountProblem
            t.li '.tabbed-pane-nav-item', ->
              t.a '.tabbed-pane-nav-item-button.js-billing', 'data-tab': 'billing-issue', href: ['', username, 'billing'].join('/'), ->
                t.format 'billing-issue'
          else
            if hasAccount
              t.li '.tabbed-pane-nav-item', ->
                t.a '.tabbed-pane-nav-item-button.js-billing', 'data-tab': 'billing', href: ['', username, 'billing'].join('/'), ->
                  t.format 'billing'
            else
              t.li '.tabbed-pane-nav-item', ->
                t.a '.tabbed-pane-nav-item-button.js-billing', 'data-tab': 'trello-gold', href: ['', username, 'billing'].join('/'), ->
                  t.span '.icon-lg.icon-trello-gold.mod-inline.icon-trello-gold-color'
                  t.text ' '
                  t.format 'trello-gold'

      return

  t.div '.tabbed-pane-main-col.u-clearfix.mod-wider', ->
    t.div '.tabbed-pane-main-col-loading.hide.js-loading-page', ->
      t.span '.tabbed-pane-main-col-loading-spinner.spinner'
    t.div '.tabbed-pane-main-col-wrapper.js-content'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/member_detail.coffee